import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Globals } from '../../ressources/variables/globals';

/**
 * Service pour les opérations d'administration
 * Note: L'authentification est gérée automatiquement via les cookies de session Laravel
 * grâce à l'intercepteur CredentialsInterceptor
 */
@Injectable()
export class AdminService {

  serverEndpoint = Globals.serverEndpoint;

  constructor(private http: HttpClient) { }

  getCurrentArl(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.serverEndpoint + '/admin/getCurrentArl', {}, { headers }).toPromise();
  }

  editArl(arl: string): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('arl', arl);

    return this.http.post(this.serverEndpoint + '/admin/editArl', body.toString(), { headers }).toPromise();
  }

  getUsers(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.serverEndpoint + '/admin/getUsers', {}, { headers }).toPromise();
  }

  getRoles(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.serverEndpoint + '/admin/getRoles', {}, { headers }).toPromise();
  }

  /**
   * Enregistre ou met à jour les préférences d'un utilisateur dans DU_users
   * Fait automatiquement un INSERT ou UPDATE côté backend
   */
  saveUserSettings(uid_editedUser: number, role: number, categorie: string, stations: string, hiddencolumns: string, preferNickname: boolean = false, lowBitrateAllowed: boolean = false): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    let body = new HttpParams().set('uid_editedUser', uid_editedUser);

    if (role !== null && role !== undefined) body = body.set('role_editedUser', role);
    if (categorie !== null && categorie !== undefined) body = body.set('categorie_editedUser', categorie);
    if (stations !== null && stations !== undefined) body = body.set('stations_editedUser', stations);
    if (hiddencolumns !== null && hiddencolumns !== undefined) body = body.set('hiddencolumns_editedUser', hiddencolumns);
    body = body.set('prefer_nickname_editedUser', String(preferNickname));
    body = body.set('low_bitrate_allowed_editedUser', String(lowBitrateAllowed));

    return this.http.post(this.serverEndpoint + '/admin/saveUserSettings', body.toString(), { headers }).toPromise();
  }

  /**
   * Supprime les préférences personnalisées d'un utilisateur de DU_users
   * L'utilisateur continuera d'exister dans Laravel mais utilisera les paramètres par défaut
   */
  removeUserSettings(uid_editedUser: number): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('uid_editedUser', uid_editedUser);

    return this.http.post(this.serverEndpoint + '/admin/removeUserSettings', body.toString(), { headers }).toPromise();
  }

  getRoleConfigs(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.serverEndpoint + '/admin/getRoleConfigs', {}, { headers }).toPromise();
  }

  addCategorie(catLabel: string, importSons: boolean, preselectPlaylist: boolean, editWinmediaFlag: boolean = false): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('catLabel', catLabel)
      .set('importSons', importSons.toString())
      .set('preselectPlaylist', preselectPlaylist.toString())
      .set('editWinmediaFlag', editWinmediaFlag.toString());

    return this.http.post(this.serverEndpoint + '/admin/addCategorie', body.toString(), { headers }).toPromise();
  }

  getAdminCategories(): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.serverEndpoint + '/admin/getAdminCategories', {}, { headers }).toPromise();
  }

  updateCategorie(id: number, catLabel: string, importSons: boolean, preselectPlaylist: boolean, editWinmediaFlag: boolean = false): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('id', id.toString())
      .set('catLabel', catLabel)
      .set('importSons', importSons.toString())
      .set('preselectPlaylist', preselectPlaylist.toString())
      .set('editWinmediaFlag', editWinmediaFlag.toString());

    return this.http.post(this.serverEndpoint + '/admin/updateCategorie', body.toString(), { headers }).toPromise();
  }

  deleteCategorie(id: number): Promise<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const body = new HttpParams()
      .set('id', id.toString());

    return this.http.post(this.serverEndpoint + '/admin/deleteCategorie', body.toString(), { headers }).toPromise();
  }
}
